<ng-container *ngIf="visible">
  <div class="modal-backdrop fade show"></div>
  <div class="modal fade show" style="display: block;" tabindex="-1" role="dialog" aria-modal="true" (click)="close()">
    <div class="modal-dialog modal-dialog-centered" role="document" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{'COMMON.HISTORY' | translate}} - {{ relatedAccountId }}</h5>
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="close()"
          ></button>
        </div>
        <div class="modal-body" #modalBody [style.max-height.px]="modalBodyMaxHeight">
          <div *ngIf="history.length == 0">
            There is no service request history available.
          </div>
          <div class="history-entry" *ngFor="let item of history">
            <div class="row">
              <div>{{'SERVICE_REQUEST_HISTORY.DATE_TIMESTAMP' | translate}}</div>
              <div>{{ item.applicationDate | utcDate : 'dd/MM/yyyy HH:mm' }}</div>
            </div>
            <div class="row">
              <div>{{'METER_REQUEST.SERVICE_ORDER_ID' | translate}}</div>
              <div>{{ item.serviceOrderId | hasValue }}</div>
            </div>
            <div class="row">
              <div>{{'SERVICE_REQUEST_HISTORY.MAP_ID' | translate}}</div>
              <div>{{ item.mapId | hasValue }}</div>
            </div>
            <div class="row">
              <div>{{'SERVICE_REQUEST_HISTORY.SERVICE_REQUEST_TYPE' | translate}}</div>
              <div>{{ item.serviceRequestType | hasValue }}</div>
            </div>
            <div class="row">
              <div>{{'SERVICE_REQUEST_HISTORY.METER_PHASE' | translate}}</div>
              <div>{{ item.meterPhase | hasValue }}</div>
            </div>
            <div class="row">
              <div>{{'SERVICE_REQUEST_HISTORY.MAP_VENDOR' | translate}}</div>
              <div>{{ item.mapVendor | hasValue }}</div>
            </div>
            <div class="row">
              <div>{{'SERVICE_REQUEST_HISTORY.PROJECT_STATUS' | translate}}</div>
              <div>{{ item.projectStatus | hasValue }}</div>
            </div>
            <div class="row">
              <div>{{'SERVICE_REQUEST_HISTORY.PROJECT_DESIGNATION' | translate}}</div>
              <div>{{ item.projectDesignation | hasValue }}</div>
            </div>
            <div class="row">
              <div>{{'SERVICE_REQUEST_HISTORY.SURVEY_SUBMISSION_DATE' | translate}}</div>
              <div>{{ item.surveySubmittedDate | utcDate : 'dd/MM/yyyy HH:mm' }}</div>
            </div>
            <div class="row">
              <div>{{'SERVICE_REQUEST_HISTORY.INSTALLATION_SUBMISSION_DATE' | translate}}</div>
              <div>{{ item.installationSubmittedDate | utcDate : 'dd/MM/yyyy HH:mm' }}</div>
            </div>
            <div class="load-requirement-block">
              <div class="load-requirement-label">{{'SERVICE_REQUEST_HISTORY.LOAD_REQUIREMENT' | translate}}:</div>
              <div class="load-requirement-item" *ngFor="let loadItem of item.loadRequirements">
                {{ loadItem.name }} ({{ loadItem.number }} &times; {{ loadItem.wattage }}W)
              </div>
              <div *ngIf="!item.loadRequirements?.length">{{ null | hasValue }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
